import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ExperiencePage } from './pages/ExperiencePage';
import { CredentialsPage } from './pages/CredentialsPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <HashRouter data-id="element-0">
      <div className="min-h-screen bg-navy-900 text-white selection:bg-gold-500 selection:text-navy-900 flex flex-col" data-id="element-1">
        <Navigation data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/experience" element={<ExperiencePage data-id="element-8" />} data-id="element-7" />
            <Route path="/credentials" element={<CredentialsPage data-id="element-10" />} data-id="element-9" />
            <Route path="/services" element={<ServicesPage data-id="element-12" />} data-id="element-11" />
            <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
          </Routes>
        </main>
        <Footer data-id="element-15" />
      </div>
    </HashRouter>;
}